import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/audit-logs");
      setItems(data);
    })();
  }, []);
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight text-[#1a1c19] sm:text-3xl">Audit Log</h1>
        <p className="text-sm text-[#5c665a]">All configuration changes and review actions.</p>
      </div>
      <div className="admin-card overflow-x-auto p-0">
        <table className="min-w-full text-sm">
          <thead className="bg-[#fafcfa] text-left text-xs uppercase tracking-wider text-[#5c665a]">
            <tr><th className="px-4 py-3">When</th><th className="px-4 py-3">Actor</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Entity</th><th className="px-4 py-3">Metadata</th></tr>
          </thead>
          <tbody className="divide-y divide-[#e2e8e2]" data-testid="audit-table">
            {items.map((a) => (
              <tr key={a.id}>
                <td className="px-4 py-2 text-xs text-[#5c665a]">{a.created_at?.slice(0, 19).replace("T", " ")}</td>
                <td className="px-4 py-2 text-xs">{a.actor}</td>
                <td className="px-4 py-2"><span className="badge-green">{a.action}</span></td>
                <td className="px-4 py-2 text-xs">{a.entity}{a.entity_id ? ` · ${a.entity_id.slice(0, 8)}` : ""}</td>
                <td className="px-4 py-2 max-w-md truncate font-mono text-xs text-[#5c665a]" title={JSON.stringify(a.metadata)}>{JSON.stringify(a.metadata)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
